const ENQUEUE_ERROR_CODES: Readonly<Record<string, string>> = Object.freeze({
  queue_not_found: 'publishQueues.errors.queueNotFound',
  queue_no_accounts: 'publishQueues.errors.queueNoAccounts',
  invalid_copy: 'publishQueues.errors.invalidCopy',
  clip_not_rendered: 'publishQueues.errors.clipNotRendered',
  clip_not_found: 'publishQueues.errors.clipNotFound',
  connection_reconnect_required: 'publishQueues.errors.connectionReconnectRequired',
  connection_unusable: 'publishQueues.errors.connectionReconnectRequired',
  publishing_disabled: 'publishQueues.errors.publishingDisabled',
});

export function isApprovedEnqueueErrorCode(value: unknown): value is string {
  return typeof value === 'string'
    && Object.prototype.hasOwnProperty.call(ENQUEUE_ERROR_CODES, value);
}

/** Returns i18n key under publishQueues.errors.* */
export function mapEnqueueError(code: string | undefined): string {
  if (!isApprovedEnqueueErrorCode(code)) {
    return 'publishQueues.errors.unknown';
  }

  return ENQUEUE_ERROR_CODES[code];
}
